import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../buttons/PrimaryButton";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { UserBadge } from "../common/UserBadge";
import { UserRentalDetail } from "../../api/requests/interfaces/Rental";
import { RentalStatus } from "../../api/requests/interfaces/Channel";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

export interface RentalStatusCardProps {
    data: UserRentalDetail
}

export const ActiveRentalStatusCard: React.FC<RentalStatusCardProps> = (props) => {
    // let status: any = RentalStatus.IN_PROGRESS;
    const [data, setData] = useState(props.data);
    const navigate = useNavigate();

    useEffect(() => {
        console.log('chat id ', data.chatChannelId);
    }, [props])

    return (
        <div className="rounded-lg shadow-main p-5">
            <div className="w-full flex justify-start h-[4px] relative items-center justify-items-center align-middle py-5">
                <div className="w-full bg-gray-200 h-1 absolute"></div>
                <div className={`h-[6px] ${data.state === RentalStatus.MESSAGE_SENT ? "w-1/6 rounded-md" :
                    data.state === RentalStatus.IN_RENT ? "w-1/2" : "w-full"} ${data.state === RentalStatus.MESSAGE_SENT ? "bg-yellow-500" :
                        data.state === RentalStatus.IN_RENT ? "bg-green-500" : "bg-gray-500"} rounded-sm z-[1]`}>
                </div>
                {/* <div className={`${data.state === RentalStatus.MESSAGE_SENT ? "bg-yellow-500" : data.state === RentalStatus.IN_RENT ? "bg-green-500" : "bg-gray-500"} z-[2] w-3 h-3 rounded-full absolute left-0 -translate-x-1/2 border border-black`}> */}
                <div className={`bg-transparent z-[2] rounded-full absolute left-0`}>
                    <div className="text-[13px] font-semibold text-gray-500 translate-y-[-120%] w-fit text-left">Vestlus pooleli</div>
                </div>
                {/* <div className={`${data.state === RentalStatus.MESSAGE_SENT ? "bg-white" : data.state === RentalStatus.IN_RENT ? "bg-green-500" : "bg-gray-500"} z-[2] w-3 h-3  rounded-full absolute left-1/3 -translate-x-1/2 border border-black`}> */}
                <div className={`bg-transparent z-[2] rounded-full absolute left-1/2 -translate-x-1/2`}>
                    <div className="text-[13px] font-semibold text-gray-500 translate-y-[-120%] text-left">Rendis</div>
                </div>
                {/* <div className={`${data.state === RentalStatus.MESSAGE_SENT ? "bg-white" : data.state === RentalStatus.IN_RENT ? "bg-white" : "bg-gray-500"} z-[2] w-3 h-3 rounded-full absolute left-2/3 -translate-x-1/2 border border-black`}> */}
                <div className={`bg-transparent z-[2] rounded-full absolute left-full -translate-x-full`}>
                    <div className="text-[13px] font-semibold text-gray-500 translate-y-[-120%] text-left">Tagastatud</div>
                </div>
            </div>
            <div className="flex flex-col lg:flex-row justify-between gap-x-6">
                <div className="flex flex-row gap-3">
                    <img className="w-[150px] h-[150px] object-cover rounded-md flex-none" src={data.product.imageUrl}></img>
                    <div className="flex flex-col text-left w-full">
                        <h3 className="pb-1">{data.product.title}</h3>
                        <div className="flex flex-row pb-1 text-sm">
                            <div>Staatus: </div>
                            <div className={`pl-2 ${data.state === RentalStatus.MESSAGE_SENT ? "text-yellow-500" : data.state === RentalStatus.IN_RENT ? "text-green-500" : "text-gray-500"}`}>
                                {data.state === RentalStatus.MESSAGE_SENT ? "Vestlus pooleli" : data.state === RentalStatus.IN_RENT ? "Rendis" : "Lõpetatud"}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-row">
                    <div className="w-[150px] flex flex-col gap-y-2 text-left text-sm">

                        <div className="flex flex-row items-center mt-2">
                            <PlaceOutlinedIcon style={{ width: "22px", height: "22px" }} />
                            <div className="pl-2">{data.product.location}</div>
                        </div>
                        <div className="flex flex-row items-center">
                            <CalendarTodayOutlinedIcon style={{ width: "22px", height: "22px" }} />
                            <div className="pl-2">{format(data.startDate, 'dd.MM.yy, HH:mm')} - {format(data.endDate, 'dd.MM.yy, HH:mm')}</div>
                        </div>
                    </div>

                    <div className="flex flex-col gap-2 text-start">
                        <div className="flex flex-row ml-5 mt-2 gap-x-4 lg:w-[200px]">
                            <div>
                                <h4>Hind:</h4>
                                <div className="text-xl font-bold flex flex-row">{data.product.dayPrice}
                                    <div className="font-light text-sm pl-1">€/päev</div>
                                </div>
                            </div>
                            <div>
                                <h4>Hind kokku</h4>
                                <div className="font-semibold">{data.amount}€</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-row gap-2 mt-2">
                <PrimaryButton icon={<MailOutlineIcon style={{ width: "24px", height: "24px" }} />} title="Sõnumitesse" onClick={() => { navigate('/chats?selectedChatId=' + data.chatChannelId.toString()) }} widthFit={true}></PrimaryButton>
                <PrimaryButton title="Toote lehele" onClick={() => { navigate('/detail/' + data.product.id.toString()) }} widthFit={true} outlined={true}></PrimaryButton>
            </div>
        </div>
    )
}